import React from 'react';
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults';
import { useTrans } from 'base/utils/i18n';
import styles from './index.module.less';

type IProps = {
}

const ResultsComeingSoon: React.FC<IProps> = (props) => {
    const { t } = useTrans();

    return(
        <div className={styles['soon-wrap']}>
            <h3 className={styles.title}>{t('web_shop_activity_early_access_application_eriod_closed')}</h3>

            <div className={styles.msg}>
                <p>{t('web_shop_activity_early_access_announced_soon')}</p>
            </div>

        </div>
    );
};

export default ResultsComeingSoon;